<template>
  <div>
    <b-modal
      id="multi-customer-modal"
      v-model="isVisible"
      modal-class="multi-branch-modal"
      content-class="multi-branch-modal__content"
      body-class="multi-branch-modal__body-wrapper"
      size="xl"
      centered
    >
      <template #modal-header>
        <div class="w-100 d-flex justify-content-between align-items-start">
          <div>          
            <h4 class="mb-0 font-weight-bold">เลือกสาขาพื่อเตรียมสร้างใบงานใหม่</h4>        
          </div>
          <b-button variant="link" class="p-0 text-secondary" @click="onCancel">✕</b-button>
        </div>
      </template>

      <div class="multi-branch-modal__body">
        <b-row no-gutters class="h-100">
          <b-col lg="6" class="pr-lg-2 mb-3 mb-lg-0">
            <div class="d-flex justify-content-between font-weight-bold mb-1">
              <span>ค้นหาสาขา</span>
              <span v-if="isOverOneHundred" class="text-danger text-sm font-weight-bold">
                Brand นี้มีจำนวนมากกว่า 100 รายการ ให้ทำการพิมพ์เพื่อค้นหาเพิ่มเติม
              </span>
            </div>
            <b-input-group class="mb-1">
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>
              <b-form-input
                v-model="keyword"
                @input="searchBranch"
                placeholder="พิมพ์ชื่อสาขา เช่น ขอนแก่น, บางนา, เชียงใหม่"
              />
            </b-input-group>

            <div class="d-flex justify-content-between align-items-center mb-2">
              <div class="font-weight-bold">ผลการค้นหา</div>
              <small class="text-muted">{{ branchCandidates.length }} รายการ</small>
            </div>     

            <div class="multi-branch-result-list">
              <div v-if="isLoading" class="text-center text-muted py-3">
                <b-spinner small class="mr-1" /> กำลังโหลดข้อมูลสาขา...
              </div>
              <div
                v-else
                v-for="branch in branchCandidates"
                :key="branch.id || branch.branchCode"
                class="multi-branch-result-item"
                :class="{ 'multi-branch-result-item--disabled': isCurrentBranch(branch) }"
              >
                <div class="d-flex align-items-center text-truncate pr-2">
                  <span class="multi-branch-code mr-2">{{ branch.branchCode }}</span> 
                  <div class="text-truncate">
                    <div class="font-weight-bold text-truncate">
                      <span v-if="branchUsedHolder[branch.branchCode]" class="text-danger">{{ branch.branchName }}</span>
                      <span v-else>{{ branch.branchName }}</span>
                    </div>
                    <small class="text-muted d-block text-truncate">{{ branch.address || "-" }}</small>
                  </div>
                </div>
                <b-button
                  size="sm"
                  :variant="isCurrentBranch(branch) || isSelected(branch.branchCode) ? 'secondary' : 'primary'"
                  :disabled="isSelected(branch.branchCode) || isCurrentBranch(branch)"
                  @click="toggleSelect(branch)"
                >
                  {{
                    isCurrentBranch(branch)
                      ? "สาขาปัจจุบัน"
                      : isSelected(branch.branchCode)
                      ? "เพิ่มแล้ว"
                      : "เพิ่มสาขา"
                  }}
                </b-button>
              </div>
            </div>
          </b-col>

          <b-col lg="6" class="pl-lg-2 d-flex flex-column">
            <div class="multi-branch-selected">              
              <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                  <div class="font-size-lg font-weight-bolder text-primary">รายการเตรียมสร้างใบงาน</div>
                  <small class="text-muted">สาขาที่เลือกไว้รอบนี้</small>
                  <span v-if="selectedBranches.length > 0" class="ml-2 text-muted font-weight-bolder">{{ selectedBranches.length }} รายการ</span>
                </div>
                
                <b-button
                  size="sm"
                  variant="outline-danger"
                  :disabled="selectedBranches.length === 0"
                  @click="removeAllBranches"
                >
                  นำออกทั้งหมด
                </b-button>
              </div>

              <div class="multi-branch-selected-list">
                <div
                  v-for="branch in selectedBranches"
                  :key="`selected-${branch.branchCode}`"
                  class="multi-branch-selected-item"
                >
                  <div class="d-flex align-items-center text-truncate pr-2">
                    <span class="multi-branch-code mr-2">{{ branch.branchCode }}</span>
                    <div class="text-truncate">
                      <div class="text-primary font-weight-bolder text-truncate">{{ branch.branchName }}</div>
                      <small class="text-muted d-block text-truncate">{{ branch.address || "-" }}</small>
                    </div>
                  </div>
                  <b-button size="sm" variant="outline-danger" @click="removeBranch(branch.branchCode)">เอาออก</b-button>
                </div>
              </div>
            </div>
            <b-form-checkbox v-model="isNotSendEmail" class="multi-branch-send-email mt-2">
              <span class="ml-2">ไม่ส่ง Email</span>
            </b-form-checkbox>
          </b-col>
        </b-row>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end multi-branch-modal__footer">
          <b-button variant="outline-secondary" class="mr-2" @click="onCancel">ยกเลิก</b-button>
          <b-button variant="success" @click="onConfirm">ตกลง</b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  BButton,
  BRow,
  BCol,
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BFormCheckbox,
  BSpinner,
} from "bootstrap-vue";
import CustomerService from "@/services/setting/customer";
import TicketService from "@/services/ticket";
import { GET_CURRENT_DATE } from "@/utils/";
import _ from "lodash";
import moment from "moment";


export default {
  components: {
    BModal,
    BButton,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BFormCheckbox,
    BSpinner,
  },
  props: {
    branchId:{
      type:[Number, String],      
    },
    branchCode: {
      type: String,      
    },
    subCompanyId: {
      type: Number,      
    },
    ticketNo:{
      type: String
    }
  },
  data() {
    return {
      isVisible: false,
      isLoading: false,
      keyword: "",
      branchCandidates: [],
      selectedBranches: [],
      isNotSendEmail: false,
      isOverOneHundred: false,
      branchUsedHolder:{}
    };
  },
  watch:{
    ticketNo(){
      console.log("ticketNo", this.ticketNo);
      this.getUsedTicket()
    }
    
  },
  methods: {
    async show() {
      this.isVisible = true;
      this.keyword = "";
      this.isNotSendEmail = false;
      await this.getBranchList();
    },
    hide() {
      this.isVisible = false;
    },
    onCancel() {
      this.hide();
    },
    onConfirm() {
      const userData = JSON.parse(localStorage.getItem("userData") || "{}");
      const payload = {        
        timestamp: GET_CURRENT_DATE().timestamp,
        branches: this.selectedBranches.map((branch) => ({
          customerId: branch.id || branch.branchId,
          customerCode:branch.branchCode
        })),
        userId: userData.userId || null,
        isNotSendEmail: this.isNotSendEmail,
      };

      if(payload.branches.length == 0){
        alert("กรุณาเลือกสาขาอย่างน้อย 1 สาขา");
        return;
      }

      this.$emit("onConfirm", payload);
      this.hide();
    },
    isSelected(branchCode) {
      return this.selectedBranches.some((branch) => branch.branchCode === branchCode);
    },
    isCurrentBranch(branch) {
      const hasBranchId = this.branchId !== null && this.branchId !== undefined;
      const branchId = branch?.id || branch?.branchId || branch?.customerBranchId;
      const isSameId = hasBranchId && Number(branchId) === Number(this.branchId);

      const normalizedCurrentCode = String(this.branchCode || "").trim().toLowerCase();
      const normalizedBranchCode = String(branch?.branchCode || "").trim().toLowerCase();
      const isSameCode = normalizedCurrentCode !== "" && normalizedCurrentCode === normalizedBranchCode;

      return isSameId || isSameCode;
    },
    toggleSelect(branch) {
      const branchData = this.branchUsedHolder[branch.branchCode]
      if(branchData){
        const isconfirm = confirm(`ตรวจพบรายละเอียดใบงานปัญหาของสาขานี้ซ้ำ และ Close โดย ${branchData.fullname} เมื่อเวลา ${moment(branchData.closeTicketDate).subtract(7, 'hours').format("HH:mm")} (${branchData.ticketNo}) จะดำเนินการต่อหรือไม่?`)
        if(!isconfirm){
          return
        }
      }
      if (this.isCurrentBranch(branch)) return;
      if (this.isSelected(branch.branchCode)) {
        this.removeBranch(branch.branchCode);
        return;
      }
      this.selectedBranches.push({ ...branch });
    },
    removeBranch(branchCode) {
      this.selectedBranches = this.selectedBranches.filter((branch) => branch.branchCode !== branchCode);
    },
    removeAllBranches() {
      this.selectedBranches = [];
    },
    async getBranchList() {
      try {
        this.isLoading = true;
        const result = await CustomerService.GetCustomerBranchListPHP(
          this.subCompanyId,
          {},
          "limit=100"
        );
        this.branchCandidates = result?.data?.data || [];
        const total = Number(result?.data?.total || 0);
        const dataLength = (result?.data?.data || []).length;
        this.isOverOneHundred = total > 100 || dataLength > 100;
      } catch (error) {
        this.branchCandidates = [];
        this.isOverOneHundred = false;
        console.log("can't get multi branch list");
      } finally {
        this.isLoading = false;
      }
    },
    searchBranch: _.debounce(async function () {      
      if (!this.keyword || this.keyword.length < 3) {
        await this.getBranchList();
        return;
      }

      try {
        this.isLoading = true;
        const result = await CustomerService.SearchBranchStockPHP(
          this.subCompanyId,
          this.keyword
        );
        this.branchCandidates = result?.data?.data || [];
      } catch (error) {
        this.branchCandidates = [];
        console.log("can't search multi branch");
      } finally {
        this.isLoading = false;
      }
    }, 1000),

    async getUsedTicket(){
      const result = await TicketService.GetUsedTicketMultiple(this.ticketNo)
      console.log("getUsedTicket", result)
      const obj = {}
      if(result.status=="success"){
        result.data.forEach((t)=>{
          obj[t.branchCode] = t
        })
      }

      this.branchUsedHolder = obj
      console.log("used list=>", result, obj)
    }
  },
};
</script>

<style scoped>
>>> .multi-branch-modal .modal-dialog {
  max-width: min(1680px, calc(100vw - 112px));
  width: 100%;
  margin-top: 24px !important;
  margin-bottom: 24px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

>>> .multi-branch-modal__content {
  height: calc(100vh - 48px);
}

>>> .multi-branch-modal .modal-header {
  border-bottom: 1px solid #e9ecef;
}

>>> .multi-branch-modal__body-wrapper {
  padding: 16px !important;
  overflow: hidden;
}

.multi-branch-modal__body {
  height: calc(100vh - 210px);
}

.multi-branch-result-list {
  height: calc(100vh - 360px);
  max-height: calc(100vh - 360px);
  overflow-y: auto;
  padding-right: 4px;
  -webkit-overflow-scrolling: touch;
}

.multi-branch-result-item {
  border: 1px solid #dbe3ec;
  border-radius: 12px;
  padding: 10px 12px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.multi-branch-result-item--disabled {
  background: #f2f4f7;
  border-color: #d8dee6;
}

.multi-branch-result-item--disabled .multi-branch-code {
  background: #e3e8ef;
  color: #7f8a9c;
}

.multi-branch-result-item--disabled .font-weight-bold,
.multi-branch-result-item--disabled small {
  color: #8e98a8 !important;
}

.multi-branch-code {
  background: #edf1f8;
  color: #6b768a;
  border-radius: 999px;
  font-weight: 700;
  font-size: 12px;
  padding: 4px 10px;
}

.multi-branch-selected {
  background: #f5f7fc;
  border-radius: 14px;
  padding: 14px;
  min-height: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.multi-branch-count {
  width: 30px;
  height: 30px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #e9edf5;
  font-weight: 700;
}

.multi-branch-selected-list {
  height: auto;
  max-height: none;
  min-height: 0;
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.multi-branch-selected-item {
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  background: #fff;
  padding: 10px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.multi-branch-guide {
  background: #f7f7f9;
  border-radius: 12px;
  padding: 12px;
}

.multi-branch-modal__footer {
  border-top: 1px solid #e9ecef;
  padding-top: 12px;
}

.multi-branch-send-email {
  padding-left: 2px;
  margin-top: 8px;
  flex-shrink: 0;
}

@media (max-width: 991px) {
  >>> .multi-branch-modal .modal-dialog {
    max-width: none;
    width: 100%;
    margin-top: 12px !important;
    margin-bottom: 12px !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }

  >>> .multi-branch-modal__content {
    height: calc(100vh - 16px);
  }

  .multi-branch-modal__body {
    height: calc(100vh - 260px);
    overflow-y: auto;
  }

  .multi-branch-selected {
    height: auto;
    min-height: 240px;
  }

  .multi-branch-result-list {
    height: 280px;
    max-height: 280px;
  }

  .multi-branch-selected-list {
    height: 300px;
    max-height: 300px;
  }
}
</style>
